import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import Box from '@material-ui/core/Box'

import Close from '@material-ui/icons/Close'

import React, { useEffect, useState } from 'react'
import { useFeatures } from '../../../hooks/Features/useFeatures'
import useValidation from '../../../hooks/Validation/useValidation'
import CustomButton from '../../CustomButton'
import CustomHeading from '../../CustomHeading'
import CustomInput from '../../CustomInput'
import CustomSelect from '../../CustomSelect'
import { config } from '../../../utils/uploadImage'
import { Avatar, CircularProgress, makeStyles } from '@material-ui/core'
import Loader from '../../Loader'

const useStyles = makeStyles((theme) => ({
  input: {
    [theme.breakpoints.up('md')]: {
      //
    },
    [theme.breakpoints.up('lg')]: {
      width: '100%',
    },
  },
}))

export default function CategoryForm({ category, handleClose }) {
  const classes = useStyles()
  const [name, setName] = useState(category ? category.categoryName : '')
  const [image, setImage] = useState(category ? category.image : '')
  const [description, setDescription] = useState(category ? category.description : '')

  useEffect(() => {
    if (category) {
      setName(category.categoryName)
      setImage(category.image)
      setDescription(category.description)
    }
  }, [category])

  const { handleValidation, error } = useValidation()

  const { categories, addCategory, updateCategory, loading } = useFeatures()

  const productInputs = [
    { label: 'Name', value: name, handleChange: setName },
    { label: 'Description', value: description, handleChange: setDescription },
    { handleChange: setImage, type: 'file' },
  ]

  const handleAddCategory = async () => {
    addCategory({
      categoryName: name,
      description,
      image,
    })
    handleClose()
    setName('')
    setDescription('')
  }
  const handleEditCategory = async () => {
    updateCategory({
      categoryId: category._id,
      categoryName: name,
      description,
      image,
    })
    handleClose()
    setName('')
    setDescription('')
  }

  const disableButton = name && description && image ? false : true

  return (
    <>
      <Box display="flex" justifyContent="space-between">
        <CustomHeading heading={category ? 'Update Category' : 'Add Category'} />
        <IconButton color="inherit" onClick={handleClose} size="small">
          <Close />
        </IconButton>
      </Box>
      <br />
      <Grid container>
        {productInputs.map((item, index) => (
          <Grid item lg={12} key={index}>
            {item.select ? (
              <>
                <CustomSelect
                  label={item.label}
                  value={item.value}
                  handleChange={item.handleChange}
                  onKeyDown={() => handleValidation(item.type, item.value)}
                  errorMessage={error && item.error}
                  options={categories}
                />
                <br />
              </>
            ) : (
              <>
                <CustomInput
                  label={item.label}
                  value={item.value}
                  handleChange={item.handleChange}
                  onKeyDown={() => handleValidation(item.type, item.value)}
                  errorMessage={error && item.error}
                  type={item.type ? item.type : 'text'}
                  className={classes.input}
                />

                <br />
              </>
            )}
          </Grid>
        ))}

        {category ? (
          <div style={{ display: 'flex', margin: '0 auto' }}>
            <Avatar src={category.image} />
          </div>
        ) : null}

        <Grid item lg={12}>
          <CustomButton
            disabled={loading}
            text={loading ? <CircularProgress size="25px" color="inherit" /> : category ? 'Update' : 'Add'}
            handleSubmit={category ? handleEditCategory : handleAddCategory}
            disabled={disableButton}
          />
        </Grid>
      </Grid>
    </>
  )
}
